import React, { useState } from 'react';
import StateDropDown from './StateDropDown';
import { AddressInput } from '../AddressInput';
import AddressUtility from '../addressUtility';

export default function SegmentedAddressInput({ update, valid, isValid, ...addr }) {
  const [touched, setTouched] = useState({
    street: false,
    city: false,
    zip: false
  });

  let { line1, line2, city, state, zip } = addr;

    if (!isValid){
      line2 = "";
      city = "";
      state = "";
      zip = "";
    }

  const handleStreetFocus = () => {
    setTouched(prev => ({ ...prev, street: true }));
  };

  const handleCityFocus = () => {
    setTouched(prev => ({ ...prev, city: true }));
  };

  const handleZipFocus = () => {
    setTouched(prev => ({ ...prev, zip: true }));
  };

  return (
    <div className="address pad-desk">
      <div>
        <AddressInput
          placeholder="Address"
          className="street-number"
          value={line1}
          onFocus={handleStreetFocus}
          onChange={(addr,valid) => update(AddressUtility.fromGeocode(addr), valid)}
        />
        {touched.street && !line1 ? (
          <span className="fields-invalid streetInvalid">
            Street is required.
    </span>) : null}
      </div>
      <input
        type="text"
        placeholder="Apt, Suite, Etc (optional)"
        className="apt"
        value={line2}
        maxLength={100}
        onChange={e => update({ ...addr, line2: e.target.value },valid)}
      />
      <div className="region">
        <div className="validationClass">
          <input
            type="text"
            placeholder="City"
            className={`city ${touched.city && !city ? 'invalid' : ''}`}
            value={city}
            maxLength={100}
            disabled={true}
            onFocus={handleCityFocus}
            onChange={e => update({ ...addr, city: e.target.value},valid)}
          />
          {touched.city && !city ? (
            <span className="fields-invalid">
              City is required.
      </span>) : null}
        </div>
        <StateDropDown
          value={state}
          disabled={true}
          onChange={e => update({ ...addr, state: e.target.value })}
        />
        <div className="validationClass">
          <input
            type="text"
            placeholder="Zipcode"
            className={`zip ${touched.zip && !zip ? 'invalid' : ''}`}
            value={zip}
            disabled={true}
            onFocus={handleZipFocus}
            onChange={e =>
              /^\d{0,5}$/.test(e.target.value) &&
              update({ ...addr, zip: e.target.value },valid)
            }
          />
          {touched.zip && !zip ? (
            <span className="fields-invalid">
              Zipcode is required.
    </span>) : null}
        </div>
      </div>
    </div>
  );
}
